export default {
  login: {
    url: '/api/auth/login',
    method: 'post'
  },
  logout: {
    url: '/api/auth/logout',
    method: 'post'
  },
  qrLogin: {
    url: '/api/auth/qrLogin',
    method: 'post'
  }
}



// WEBPACK FOOTER //
// ./src/api/auth.js